document.addEventListener('DOMContentLoaded', () => {
  
function initPatchCustomization() {

    const dropdown = document.querySelector('.patches-dropdown');
    const selected = document.querySelector('.patches-selected');
    const selectedImage = document.querySelector('.patches-selected-image');
    const selectedText = selected.querySelector('span');
    const options = document.querySelectorAll('.patches-option');

    dropdown.addEventListener('click', () => {
        dropdown.classList.toggle('active');
    });

    options.forEach(option => {
        option.addEventListener('click', () => {
            const value = option.dataset.value;
            const text = option.querySelector('span').textContent;
            const imageSrc = option.querySelector('img').src;
            const price = option.querySelector('.patches-price').getAttribute('data-patch-price');
            const patchVariantId = option.getAttribute('data-variant-id');

            // Update selected patch
            selectedImage.src = imageSrc;
            selectedImage.alt = text;
            selectedImage.style.display = 'block'; // Make the image visible
            selectedText.textContent = text;
            selected.setAttribute('data-selected-patch-price', price);
            selected.setAttribute('data-selected-patch-id', patchVariantId);
            selected.setAttribute('data-value', value);

            updateMinimumQuantity();

            dropdown.classList.remove('active');
            console.log('Selected Value:', value); // Handle value as needed
            dropdown.classList.toggle('active');
        });
    });

    function updateMinimumQuantity() {
        const qtyInput = document.querySelector('.patch-final-buttons-section .price-per-item__container .quantity__input');
        const noteElement = document.querySelector('.patch-final-buttons-note');
        let errorMessageSpan = document.querySelector('.error-message');
        if (!qtyInput) return;

        const currentValue = selected.getAttribute('data-value') || '';
        const hasWovenInList = typeof locationDataArray !== 'undefined' && locationDataArray.some(data => data.patchHandle === 'patch-woven');
        
        const wovenRequired = (currentValue === 'patch-woven' || hasWovenInList);
        let minQty = wovenRequired ? 50 : 5;

        // Display inventory error early if possible
        const maxInventory = parseInt(qtyInput.getAttribute('max'));
        if (!isNaN(maxInventory) && minQty > maxInventory) {
            if (errorMessageSpan) {
                errorMessageSpan.innerText = `This product has only ${maxInventory} items in stock. Woven patches require a minimum of 50.`;
                errorMessageSpan.style.color = 'red';
            }
        } else {
            if (errorMessageSpan && errorMessageSpan.innerText.includes('Woven patches require')) {
                errorMessageSpan.innerText = '';
            }
        }

        qtyInput.setAttribute('min', minQty);
        qtyInput.setAttribute('data-min', minQty);
        qtyInput.setAttribute('oninput', `setTimeout(() => { if (this.value < ${minQty}) this.value = ${minQty}; }, 500);`);
        
        const currentQty = parseInt(qtyInput.value);
        if (currentQty < minQty) {
            // Bump up: current value is below the new minimum (e.g. 5 → 50 when switching to woven)
            qtyInput.value = minQty;
            qtyInput.dispatchEvent(new Event('change'));
        } else if (!wovenRequired && currentQty > minQty) {
            // Drop down: woven is no longer required, reset to the new minimum (e.g. 50 → 5)
            qtyInput.value = minQty;
            qtyInput.dispatchEvent(new Event('change'));
        }
         
        if (noteElement) {
            noteElement.textContent = `ALL PATCHES ARE MINIMUM ${minQty} UNITS PER PATCH DESIGN`;
        }
    }

    document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('active');
        }
    });

    const uploadWrap = document.querySelector('.patches-image-upload-wrap');
    const artworkPopup = document.querySelector('.artwork-upload-confirmation-popup-main');
    const fileInput = document.getElementById('patches-image-upload-input');
    const uploadedFilesContainer = document.querySelector('.patches-uploaded-files-names');
    let uploadedFile = null; // Store only a single file
    const maxTotalSizeMB = 20;
    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/eps', 'application/pdf'];

    uploadWrap.addEventListener('dragover', (event) => {
      event.preventDefault();
      uploadWrap.style.borderColor = '#000';
      uploadWrap.style.backgroundColor = '#f0f0f0';
    });

    uploadWrap.addEventListener('dragleave', () => {
      uploadWrap.style.borderColor = '#0000003D';
      uploadWrap.style.backgroundColor = 'transparent';
    });

    uploadWrap.addEventListener('drop', (event) => {
      event.preventDefault();
      uploadWrap.style.borderColor = '#0000003D';
      uploadWrap.style.backgroundColor = 'transparent';

      const file = event.dataTransfer.files[0]; // Take only the first file
      handleFile(file);
    });

    fileInput.addEventListener('change', (event) => {
      const file = event.target.files[0]; // Take only the first file
      handleFile(file);
    });

    function handleFile(file) {
      if (!file) return;

      if (!allowedFileTypes.includes(file.type)) {
        alert(`${file.name} has an unsupported file type.`);
        return;
      }

      if (file.size > maxTotalSizeMB * 1024 * 1024) {
        alert(`Adding ${file.name} exceeds the 20MB total file size limit.`);
        return;
      }

      // Store only a single file
      uploadedFile = file;
      displayFileName();
    }

    function displayFileName() {
      uploadedFilesContainer.innerHTML = '';
      if (uploadedFile) {
        const fileNameElement = document.createElement('p');
        fileNameElement.textContent = uploadedFile.name;
        uploadedFilesContainer.appendChild(fileNameElement);
        uploadWrap.style.borderColor = '#000';
        uploadWrap.style.backgroundColor = '#f0f0f0';
        artworkPopup.classList.add('popup-show');
        document.querySelector('body').classList.add('overflow-hidden');
      }
    }

    const sideRadios = document.querySelectorAll('[name="patchs-side"]');
    const imageLabels = document.querySelectorAll('.patches-image-sides label');

    sideRadios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const selectedSide = event.target.value.toLowerCase();
        imageLabels.forEach((label) => {
          if (label.getAttribute('group').toLowerCase() === selectedSide) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
        });
      });
    });

    const locationDataArray = [];
    const patcheAddButton = document.querySelector('.patche-add-button');
    const patcheConfirmButton = document.querySelector('.patche-confirm-button');
    const patcheAddToCartBtn = document.querySelector('.patche-add-to-cart-button');
    patcheAddButton.addEventListener('click', (event) => {
      event.preventDefault();

      // Check first — stop if not valid
      const isValidVariant = checkPatchVariantSelected();
      if (!isValidVariant) {
        // Exit early if variant selection is not valid
        return;
      }

      const addedPatchesWrap = document.querySelector('.added-patches-wrap');
      const customizationList = document.querySelector('.patch-added-items');
      const selectedSide = document.querySelector('[name="patchs-side"]:checked')?.value;
      const selectedImageGroup = document.querySelector(`.patches-image-sides label.active input:checked`);
      const selectedImageValue = selectedImageGroup ? selectedImageGroup.value : null;
      const selectedDecoration = document.querySelector('.patches-selected span')?.innerText.trim();
      const selectedPrice = document.querySelector('.patches-selected')?.getAttribute('data-selected-patch-price');
      const selectedPatchId = document.querySelector('.patches-selected')?.getAttribute('data-selected-patch-id');
      const uploadedFileName = uploadedFile ? uploadedFile.name : '';
      const inputText = document.querySelector('.patches-text-input').value.trim();
      const selectedPatchSize = document.querySelector(".patches-size-select").value;


      // Validation: Check required fields
      const errorMessageDiv = document.querySelector('.error-message') || document.createElement('div');
      errorMessageDiv.className = 'error-message';
      errorMessageDiv.style.color = 'red';

      if (!selectedSide || !selectedImageValue || !selectedDecoration || !uploadedFileName || !selectedPatchSize || (!selectedDecoration || selectedDecoration === 'Type of Patch')) {
        let missingFields = [];
        if (!selectedSide) missingFields.push('"Side"');
        if (!selectedImageValue || !uploadedFileName) missingFields.push('"Image"');
        if (!selectedDecoration || selectedDecoration === 'Type of Patch') missingFields.push('"Decoration"');
        if (!selectedPatchSize) missingFields.push('"Size"');
        if (missingFields.length > 0) {
          let fieldMessage = missingFields.length > 0
            ? `Please fill out all required fields. ${missingFields.join(', ')} are mandatory.`
            : '';
          let fileMessage = !uploadedFileName
            ? 'A file must be uploaded.'
            : '';
          errorMessageDiv.innerText = `${fieldMessage} ${fileMessage}`.trim();
          return;
        }
      } else {
        errorMessageDiv.innerText = ``;
      }
 
      // Validation: Inventory check for Woven
      const patchHandle = document.querySelector('.patches-selected')?.getAttribute('data-value') || '';
      const qtyInput = document.querySelector('.patch-final-buttons-section .price-per-item__container .quantity__input');
      if (qtyInput && patchHandle === 'patch-woven') {
          const maxInventory = parseInt(qtyInput.getAttribute('max'));
          if (!isNaN(maxInventory) && maxInventory < 50) {
              errorMessageDiv.innerText = `This product has only ${maxInventory} items in stock. Woven patches require a minimum of 50. Please select another decoration type.`;
              return;
          }
      }

      // Check for duplicate entries
      const duplicateFound = locationDataArray.some(entry => entry.image === selectedImageValue);
      if (duplicateFound) {
        errorMessageDiv.innerText = `The selected location has already been customized. Choose different location.`;
        return;
      } else {
        errorMessageDiv.innerText = ``;
      }

      console.log('patcheAddButton', patcheAddButton);
      patcheAddButton.innerHTML = 'PATCH ADDED...';
      setTimeout(() => {
        patcheAddButton.innerHTML = 'ADD A PATCH';
      }, 1500);

      const locationData = {
        side: selectedSide,
        image: selectedImageValue,
        decorationType: selectedDecoration,
        selectedPrice: selectedPrice,
        selectedPatchId: selectedPatchId,
        patchHandle: document.querySelector('.patches-selected')?.getAttribute('data-value') || '',
        file: uploadedFileName,
        uploadedFile: uploadedFile,
        selectedPatchSize: selectedPatchSize,
        text: inputText
      };
      locationDataArray.push(locationData);
       
      updateMinimumQuantity();
      
      if(locationDataArray.length < 1) {
        patcheAddToCartBtn.classList.add('disabled');
      } else {
        patcheAddToCartBtn.classList.remove('disabled');
      }

      // Add each property as a separate <li>
      const sideItem = document.createElement('li');
      sideItem.innerHTML = `<strong>Side:</strong> ${locationData.side}`;
      customizationList.appendChild(sideItem);

      const imageItem = document.createElement('li');
      imageItem.innerHTML = `<strong>Location:</strong> ${locationData.image}`;
      customizationList.appendChild(imageItem);

      const decorationItem = document.createElement('li');
      decorationItem.innerHTML = `<strong>Decoration:</strong> ${locationData.decorationType}`;
      customizationList.appendChild(decorationItem);

      if(locationData.file != "") {
        const fileItem = document.createElement('li');
        fileItem.innerHTML = `<strong>File:</strong> ${locationData.file}`;
        customizationList.appendChild(fileItem);
      }

      if(locationData.selectedPatchSize != "") {
        const fileItem = document.createElement('li');
        fileItem.innerHTML = `<strong>Patch Height:</strong> ${locationData.selectedPatchSize}`;
        customizationList.appendChild(fileItem);
      }

      if(locationData.text != "") {
        const textItem = document.createElement('li');
        textItem.innerHTML = `<strong>Text:</strong> ${locationData.text}`;
        customizationList.appendChild(textItem);
      }

      addedPatchesWrap.classList.remove('hidden');
    });


    patcheAddButton.addEventListener('click', (event) => {
      event.preventDefault();

      console.log('Cliked', locationDataArray);

      const productPrice = $(this).closest('.product__info-wrapper').find('.price .price-item').html();
      $('.patch-final-pricing-section .patch-product-price span').html(productPrice);

      const finalCustomizationList = document.querySelector('.patch-final-added-items');
      const patchPriceElement = document.querySelector('.patch-final-pricing-section .patch-patch-price span');
      const mainProductPriceElement = document.querySelector('.patch-final-pricing-section');
      const productPriceElement = document.querySelector('.patch-final-pricing-section .patch-product-price span');
      const SelectedProductQty = document.querySelector('.patch-final-buttons-wrap .quantity__input').value;

      let totalPriceOfPatch = parseInt(0);
      let totalPrice = parseInt(mainProductPriceElement.getAttribute('data-product-price'));
      locationDataArray.forEach((locationData, index) => {

        totalPriceOfPatch = parseInt(totalPriceOfPatch) + parseInt(locationData.selectedPrice);

        const line = document.createElement('hr');
        finalCustomizationList.appendChild(line);
      });

      if (locationDataArray.length > 0) {
        document.querySelector('#patches-add-note').style.display = 'block';
      } else {
        document.querySelector('#patches-add-note').style.display = 'none';
      }
      
      const SelectedProductSubTotal = totalPriceOfPatch + totalPrice;
      const SelectedProductTotal = SelectedProductSubTotal * SelectedProductQty;
      patchPriceElement.setAttribute('data-patch-price', totalPriceOfPatch);
      patchPriceElement.innerHTML = Shopify.formatMoney(totalPriceOfPatch, '${{amount}}');
      productPriceElement.setAttribute('data-product-price', SelectedProductSubTotal);
      productPriceElement.innerHTML = Shopify.formatMoney(SelectedProductTotal, '${{amount}}');
    });

    const patcheProductQTYInput = document.querySelector('.patch-final-buttons-section .price-per-item__container .quantity__input');
    patcheProductQTYInput.addEventListener('change', (event) => {
      const updatedQuantity = parseInt(event.target.value, 10);
      console.log("Updated Quantity:", updatedQuantity);

      const selectedPatchPriceElement = document.querySelector('.patch-final-pricing-section .patch-patch-price span');
      const selectedProductPriceElement = document.querySelector('.patch-final-pricing-section .patch-product-price span');

      if (selectedPatchPriceElement && selectedProductPriceElement) {
          const selectedPatchPrice = parseFloat(selectedPatchPriceElement.getAttribute('data-patch-price')) || 0;
          const selectedProductPrice = parseFloat(selectedProductPriceElement.getAttribute('data-product-price')) || 0;

          selectedPatchPriceElement.innerHTML = Shopify.formatMoney(updatedQuantity * selectedPatchPrice, '${{amount}}');
          selectedProductPriceElement.innerHTML = Shopify.formatMoney(updatedQuantity * selectedProductPrice, '${{amount}}');
      } else {
          console.error("Price elements not found.");
      }
    });

    const patcheAddToCartButton = document.querySelector('.patche-add-to-cart-button');
    if (patcheAddToCartButton) {
      patcheAddToCartButton.addEventListener('click', async (event) => {
          event.preventDefault();
          patcheAddToCartButton.classList.add('loading');

          const productWrapper = patcheAddToCartButton.closest('.product__info-wrapper');
        
          const productId = productWrapper.querySelector('.product-variant-id[name="id"]').value;
          const productQTY = document.querySelector('.patch-final-buttons-section .price-per-item__container .quantity__input').value;

          const form = document.createElement("form");
          form.method = "POST";
          form.action = window.Shopify.routes.root + "cart/add";
          form.enctype = "multipart/form-data";

          const variantInput = document.createElement("input");
          variantInput.type = "hidden";
          variantInput.name = "items[0][id]";
          variantInput.value = productId;
          form.appendChild(variantInput);

          const quantityInput = document.createElement("input");
          quantityInput.type = "hidden";
          quantityInput.name = "items[0][quantity]";
          quantityInput.value = productQTY;
          form.appendChild(quantityInput);

          if (!Array.isArray(locationDataArray) || locationDataArray.length === 0) {
            console.error("locationDataArray is not defined or empty.");
            return;
          }

          const relationKeyInput = document.createElement("input");
          relationKeyInput.type = "hidden";
          relationKeyInput.name = `items[0][properties][_relationKey]`;
          const randomKey = Math.random().toString(16).substring(2, 12);
          const relationKey = `${productId}:${randomKey}`;
          relationKeyInput.value = relationKey;
          form.appendChild(relationKeyInput);

          console.log('locationDataArray', locationDataArray);
          let addItemArray = [];
          locationDataArray.forEach((locationData, index) => {
            addItemArray.push({
              id: locationData.selectedPatchId,
              qty: productQTY,
              relationKey: relationKey,
              patchUniqueKey: Math.random().toString(16).substring(2, 12),
            });

            // Patch Side
            const sideInput = document.createElement("input");
            sideInput.type = "hidden";
            sideInput.name = `items[0][properties][Patch ${index + 1} Side]`;
            sideInput.value = locationData.side;
            form.appendChild(sideInput);

            // Patch Location
            const locationInput = document.createElement("input");
            locationInput.type = "hidden";
            locationInput.name = `items[0][properties][Patch ${index + 1} Location]`;
            locationInput.value = locationData.image;
            form.appendChild(locationInput);

            // Decoration Type
            const decorationInput = document.createElement("input");
            decorationInput.type = "hidden";
            decorationInput.name = `items[0][properties][Patch ${index + 1} Decoration Type]`;
            decorationInput.value = locationData.decorationType;
            form.appendChild(decorationInput);

            // File Upload Handling
            if (locationData.uploadedFile && locationData.uploadedFile instanceof File) {
              console.log('Processing file:', locationData.uploadedFile);

              const fileInput = document.createElement("input");
              fileInput.type = "file"; // Must be of type file
              fileInput.name = `items[0][properties][Patch ${index + 1} File]`;

              const dt = new DataTransfer();
              dt.items.add(locationData.uploadedFile);
              fileInput.files = dt.files;

              form.appendChild(fileInput);
            } else {
              console.log('Skipping file upload - Invalid file:', locationData.file);
            }

            // Patch Size
            if (locationData.selectedPatchSize != "") {
              const patchSizeInput = document.createElement("input");
              patchSizeInput.type = "hidden";
              patchSizeInput.name = `items[0][properties][Patch ${index + 1} Size]`;
              patchSizeInput.value = locationData.selectedPatchSize;
              form.appendChild(patchSizeInput);
            }

            // Custom Text
            if (locationData.text) {
              const textInput = document.createElement("input");
              textInput.type = "hidden";
              textInput.name = `items[0][properties][Patch ${index + 1} Text]`;
              textInput.value = locationData.text;
              form.appendChild(textInput);
            }

            // Size ID
            // const sizeId = document.querySelector("input[name='properties[size_id]']");
            // if (sizeId) {
            //   const sizeIdInput = document.createElement("input");
            //   sizeIdInput.type = "hidden";
            //   sizeIdInput.name = "items[0][properties][size_id]";
            //   sizeIdInput.value = sizeId.value;

            //   console.log("sizeIdInput", sizeIdInput);
            //   form.appendChild(sizeIdInput);
            // }
          });

          const formData = new FormData(form);
          fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              body: formData
          })
          .then(response => response.json())
          .then(data => {
              console.log("Main product added to cart:", data);
              // Now Add Additional Items via AJAX
              
              if (data.status === 422) {
                const message = data.message;

                // Case 1: Only some quantity could be added
                const partialQtyRegex = /Only (\d+) items were added to your cart due to availability/;
                const partialMatch = message.match(partialQtyRegex);

                if (partialMatch) {
                  const availableQty = parseInt(partialMatch[1], 10);
                  console.log('Available Quantity:', availableQty);

                  // Update all item quantities
                  addItemArray.forEach(item => {
                    item.qty = availableQty;
                  });

                  // Proceed with adjusted items
                  addItems(addItemArray);
                  return;
                }

                // Case 2: Max quantity already in cart
                if (message === "The maximum quantity of this item is already in your cart.") {
                  alert("This item is already at the maximum quantity in your cart.");
                  patcheAddToCartButton.classList.remove('loading');
                  return;
                }

                console.warn("Unhandled 422 message:", message);
                return;
              }

              // If no errors, proceed as normal
              addItems(addItemArray);
              addItemArray = []; // Correct var name
              locationDataArray.length = 0;
              refreshPatchesBlock();
          })
          .catch(error => console.error('Error:', error));
      });
    }

  // Function to Add Additional Items via AJAX**
  function addItems(addItemArray) {
    console.log('addItemArray', addItemArray);
    let addItemObject = [];
    addItemArray.forEach(item => {
      addItemObject.push({
        id: parseInt(item.id),
        quantity: item.qty,
        properties: {
            _relationKey: item.relationKey,
            _patchUniqueKey: item.patchUniqueKey
        }
      });
    });

    let formData = { items: addItemObject };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log("Additional Items added:", data);
      $('.drawer').removeClass('is-empty');
      updateCart();

      const patcheAddToCartButton = document.querySelector('.patche-add-to-cart-button');
      if (patcheAddToCartButton) {
        setTimeout(() => {
          patcheAddToCartButton.classList.remove('loading');
        }, 2000);
      }
    })
    .catch(error => console.error('Error:', error));
  }

  document.addEventListener('click', function (event) {
    const popupMain = document.querySelector('.artwork-upload-confirmation-popup-main');
    const popupBox = document.querySelector('.artwork-upload-confirmation-popup');
    const closeBtn = document.querySelector('.artwork-upload-confirmation-popup-close');
    if (popupMain.classList.contains('popup-show')) {
      if (!popupMain || !popupBox) return;

      const clickedInsidePopup = popupBox.contains(event.target);
      const clickedCloseButton = closeBtn && closeBtn.contains(event.target);
      const clickedPopupMain = popupMain.contains(event.target);

      if (clickedPopupMain && (!clickedInsidePopup || clickedCloseButton)) {
        popupMain.classList.remove('popup-show');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    }
  });
}

  initPatchCustomization(); 

  function refreshPatchesBlock() {
    var currentPath = window.location.pathname;
    fetch(currentPath)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newBlock = doc.querySelector('.patches-block-content');
        const currentBlock = document.querySelector('.patches-block-content');

        if (newBlock && currentBlock) {
          currentBlock.innerHTML = newBlock.innerHTML;

          // Wait for DOM update to complete before reinitializing
          requestAnimationFrame(() => {
            initPatchCustomization(); // Re-attach all event listeners
            console.log('Patches block content refreshed and re-initialized');
          });
        } else {
          console.error('patches-block-content not found in fetched HTML');
        }
      })
      .catch(err => console.error('Failed to refresh:', err));
  }


  function checkPatchVariantSelected() {
    const productInfo = document.querySelector('product-info');
    // Size option the customer must choose (see require_size in product-variant-picker.liquid)
    const foundValidVariant = isRequiredVariantOptionSelected(productInfo);

    if (foundValidVariant) {
      productInfo.classList.remove('patch-btn-variant-not-selected');
      return true;
    } else {
      productInfo.classList.add('patch-btn-variant-not-selected');
      return false;
    }
  }

});


